'use strict';

(function() {
	var settingsListener, trueDiscard;
	angular.module('onboarding.common.settings')
		.directive('cobBrokerSettings', cobBrokerSettings);

	cobBrokerSettings.$inject = [
		'brokerSettingsService', 'sessionService', 'subjectObserverMessagesService', 'observerService', 'Upload',
		'$timeout', 'validationService', '$window'
	];

	var WELCOME_MESSAGE_TOGGLE_TITLE = 'Display default welcome message';
	var WELCOME_MESSAGE_DEFAULT_TITLE = 'Default welcome message';
	var WELCOME_MESSAGE_CUSTOM_TITLE = 'Your custom welcome message';

	var CONTRACT_MESSAGE_TOGGLE_TITLE = 'Display default contract message';
	var CONTRACT_MESSAGE_DEFAULT_TITLE = 'Default contract message';
	var CONTRACT_MESSAGE_DEFAULT = 'Clicking “Sign” with a typed first and last name and title constitutes your handwritten signature.';
	var CONTRACT_MESSAGE_CUSTOM_TITLE = 'Write a custom message for carriers to see in the Contracts section. Include any special instructions you might have related to your contracts';

	var DOCUMENTS_MESSAGE_TOGGLE_TITLE = 'Display default documents message';
	var DOCUMENTS_MESSAGE_DEFAULT_TITLE = 'Default documents message';
	var DOCUMENTS_MESSAGE_DEFAULT = 'Add any documents you want to include as part of your profile, such as an authority, insurance or Hazmat certificate or schedule of vehicles.';
	var DOCUMENTS_MESSAGE_CUSTOM_TITLE = 'Your custom documents message';
	
	var brokerSettingsService,
		sessionService,
		subjectObserverMessagesService,
		observerService,
		subjectMessages,
		observerMessages,
		validationService,
		$window,
		ngFileUpload;

	function cobBrokerSettings(_brokerSettingsService_,
		_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_ngFileUpload_,
		$timeout,
		_validationService_,
		_$window_) {

		brokerSettingsService = _brokerSettingsService_;
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		validationService = _validationService_;
		$window = _$window_;
		ngFileUpload = _ngFileUpload_;

		return {
			restrict: 'E',
			scope: {
				settings: '=',
				errors: '='
			},
			templateUrl: '/app/common/settings/broker/cobBrokerSettings.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			registerEventHandlers();

			scope.view = 'notificationSettings';

			scope.toggleSettings = toggleSettings;
			scope.saveChanges = saveChanges;
			scope.insuranceMessageText = '';
			scope.welcomeMessageText = '';
			scope.discardChanges = discardChanges;
			scope.validateNotificationEmail = validateNotificationEmail;
			scope.disableNotificationEmailCheck = disableNotificationEmailCheck;
			scope.isSaveButtonDisabled = isSaveButtonDisabled;
			scope.uploadLogo = uploadLogo;
			scope.validateLogoImage = validateLogoImage;
			scope.toggleModalWindow = toggleModalWindow;
			scope.setDirty = setDirty;
			scope.logoSettings = new Object();
			scope.notificationSettings = new Object();

			initializeMessages();
		}

		function initializeMessages() {
			scope.welcomeMessages = {
				toggleTitle: WELCOME_MESSAGE_TOGGLE_TITLE,
				defaultMessageTitle: WELCOME_MESSAGE_DEFAULT_TITLE,
				customMessageTitle: WELCOME_MESSAGE_CUSTOM_TITLE,
			};
			scope.showModalWindow = false;
			scope.hostname = $window.location.origin;

			scope.contractMessages = {
				toggleTitle: CONTRACT_MESSAGE_TOGGLE_TITLE,
				defaultMessageTitle: CONTRACT_MESSAGE_DEFAULT_TITLE,
				customMessageTitle: CONTRACT_MESSAGE_CUSTOM_TITLE,
				defaultMessage: CONTRACT_MESSAGE_DEFAULT
			};

			scope.documentsMessages = {
				toggleTitle: DOCUMENTS_MESSAGE_TOGGLE_TITLE,
				defaultMessageTitle: DOCUMENTS_MESSAGE_DEFAULT_TITLE,
				customMessageTitle: DOCUMENTS_MESSAGE_CUSTOM_TITLE,
				defaultMessage: DOCUMENTS_MESSAGE_DEFAULT
			};

			clearBrokerMessages();

			scope.$watch('settings', function(value) {
				if (value && value.companyName) {
					scope.welcomeMessages.defaultMessage = 
							'Welcome. You\'ve been invited by ' + value.companyName + ' to onboard with them using DAT OnBoard.';
				}
			}, true);
		}

		function registerEventHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_SETTINGS_BROKER_OPEN, handler: onSettingsOpen },
					{ message: observerMessages.COB_OBSERVER_SETTINGS_BROKER_CLOSE, handler: onSettingsClosed }
				]);
		}

		function watcher(oldVal, newVal) {
			if (JSON.stringify(oldVal) !== JSON.stringify(newVal));
			{
				discardChanges();
			}
		}

		function onSettingsOpen() {
			scope.isAuthorizedBrokerWrite = sessionService.isAuthorizedBrokerWrite();

			scope.$watch('settings', watcher);
		}

		function onSettingsClosed() {

			scope.$watch('settings', watcher);

			scope.notificationSettings.isSearchable = null;
			scope.notificationSettings.notifyOnProfileChange = null;
			scope.notificationSettings.notifyOnW9Change = null;
			scope.notificationSettings.notifyOnInsuranceChange = null;
			scope.notificationSettings.notifyOnContractSignings = null;
			scope.notificationSettings.notifyOnAttachmentChange = null;
			scope.notificationSettings.notificationEmails = '';
			scope.notificationSettings.landingPage = null;


			scope.settings.isSearchable = null;
			scope.settings.notifyOnProfileChange = null;
			scope.settings.notifyOnW9Change = null;
			scope.settings.notifyOnInsuranceChange = null;
			scope.settings.notifyOnContractSignings = null;
			scope.settings.notifyOnAttachmentChange = null;
			scope.settings.notificationEmails = '';
			scope.settings.landingPage = null;
			scope.settings.imageMimeType = null;
			scope.settings.imageFile = null;
			scope.settings.imgUrl = null;
			scope.logoSettings = {};
			
			clearBrokerMessages();
			
			toggleSettings('notificationSettings');

			setClean();
		}

		function cloneLogo(isTrueDiscard) {
			trueDiscard = isTrueDiscard;
			if (!scope.settings) return;
			scope.logoSettings = new Object();
			scope.logoSettings.imageFile = scope.settings.imageFile;
			scope.logoSettings.imageMimeType = scope.settings.imageMimeType;
			setLogoImgURL();

			function watcher(newVal, oldVal) {
				if (trueDiscard) {
					clearDiscard();
					setClean();
					scope.ShowIsInvalidFile = false;
				} else {
					if (JSON.stringify(oldVal) !== JSON.stringify(newVal))
						setDirty();
					else
						setClean();
				}
			}

			if (!settingsListener) {
				settingsListener = scope.$watch('logoSettings', watcher, true);
			}
		}

		function cloneNotificationSettings(isTrueDiscard) {
			trueDiscard = isTrueDiscard;
			if (!scope.settings) return;
			scope.notificationSettings = new Object();
			scope.notificationSettings.landingPage = scope.settings.landingPage;
			scope.notificationSettings.isSearchable = scope.settings.isSearchable;
			scope.notificationSettings.notifyOnProfileChange = scope.settings.notifyOnProfileChange;
			scope.notificationSettings.notifyOnW9Change = scope.settings.notifyOnW9Change;
			scope.notificationSettings.notifyOnInsuranceChange = scope.settings.notifyOnInsuranceChange;
			scope.notificationSettings.notifyOnContractSignings = scope.settings.notifyOnContractSignings;
			scope.notificationSettings.notifyOnAttachmentChange = scope.settings.notifyOnAttachmentChange;
			scope.notificationSettings.notificationEmails = scope.settings.notificationEmails;
			
			function watcher(newVal, oldVal) {
				if (!oldVal.landingPage) {
					return;
				}

				if (trueDiscard) {
					clearDiscard();
					setClean();
					scope.showEmailIsNotValid = false;
				} else {
					if (JSON.stringify(oldVal) !== JSON.stringify(newVal))
						setDirty();
					else
						setClean();
				}
			}

			if (!settingsListener) {
				settingsListener = scope.$watch('notificationSettings', watcher, true);
			}
			disableNotificationEmailCheck();

			setClean();
		}

		function cloneMessage(isTrueDiscard, view) {
			trueDiscard = isTrueDiscard;
			if (!scope.settings) return;
			if (scope.settings[view]) {
				scope.settings[view] = getBrokerMessage(scope.settings[view].message, scope.settings[view].isDisabled);
				scope[view] = getBrokerMessage(scope.settings[view].message, scope.settings[view].isDisabled);
			} else {
				scope.welcomeMessage = {};
			}

			function messagesWatcher(newValue) {
				messageChanged(scope.settings[view], newValue);
			}

			if (!settingsListener) {
				settingsListener = scope.$watch(view, messagesWatcher, true);
			}
		}

		function messageChanged(oldMessage, newMessage) {
			if (isBrokerMessageValid(newMessage)) {
				if (JSON.stringify(oldMessage) !== JSON.stringify(newMessage)) {
					setDirty();
				}
				else {
					clearDiscard();
					setClean();
				}
			}
		}

		function isBrokerMessageValid(brokerMessage) {
			return brokerMessage && brokerMessage.message !== undefined && brokerMessage.isDisabled !== undefined;
		}

		function getBrokerMessage(message, disabled) {
			return {
				message: message || '',
				isDisabled: disabled || false
			};
		}

		function clearBrokerMessages() {
			scope.welcomeMessage = getBrokerMessage();
			scope.documentsMessage = getBrokerMessage();
			scope.contractMessage = getBrokerMessage();
			scope.insuranceMessage = getBrokerMessage();
			scope.signedMessage = getBrokerMessage();
		}

		function disableNotificationEmailCheck() {
			if (!scope.isAuthorizedBrokerWrite) {
				scope.disableNotificationEmail = true;
			} else if (scope.notificationSettings.notifyOnProfileChange) {
				scope.disableNotificationEmail = false;
			} else if (scope.notificationSettings.notifyOnW9Change) {
				scope.disableNotificationEmail = false;
			} else if (scope.notificationSettings.notifyOnInsuranceChange) {

				scope.disableNotificationEmail = false;
			} else if (scope.notificationSettings.notifyOnContractSignings) {
				scope.disableNotificationEmail = false;
			} else if (scope.notificationSettings.notifyOnAttachmentChange) {
				scope.disableNotificationEmail = false;
			} else {
				scope.disableNotificationEmail = true;
			}
		}

		function discardChanges(isTrueDiscard) {
			switch (scope.view) {
			case 'logoUpload':
				cloneLogo(isTrueDiscard);
				break;
			case 'notificationSettings':
				cloneNotificationSettings(isTrueDiscard);
				break;
			case 'insuranceMessage':
			case 'welcomeMessage':
			case 'contractMessage':
			case 'documentsMessage':
			case 'signedMessage':
				cloneMessage(isTrueDiscard, scope.view);
				break;
			}
		}

		function saveChanges() {
			switch (scope.view) {
			case 'logoUpload':
				saveLogo();
				break;
			case 'notificationSettings':
				saveNotificationSettings();
				break;
			case 'insuranceMessage':
			case 'welcomeMessage':
			case 'contractMessage':
			case 'documentsMessage':
			case 'signedMessage':
				saveMessage(scope.view);
				break;
			}
		}

		function saveLogo() {
			if (scope.logoSettings.imageFile !== null) {
				if (!scope.ShowIsInvalidFile &&
				(scope.logoSettings.fileName !== undefined || scope.logoSettings.fileName !== '')) {
					brokerSettingsService.updateLogo(scope.logoSettings.imageFile,
						scope.logoSettings.imageMimeType,
						scope.logoSettings.fileName,
						scope.logoSettings.fileExtension)
						.then(function() {
							scope.settings.imageFile = scope.logoSettings.imageFile;
							scope.settings.imageMimeType = scope.logoSettings.imageMimeType;
							sendSave();
						});
				}
			}
		}

		function saveNotificationSettings() {
			var notificationSettings = {};
			validateNotificationEmail();
			if (scope.showEmailIsNotValid) {
				return;
			}

			var notificationEmails1;
			if (typeof scope.notificationSettings.notificationEmails === 'string')
				notificationEmails1 = scope.notificationSettings.notificationEmails.split(',');
			else
				notificationEmails1 = scope.notificationSettings.notificationEmails;

			var notificationEmails = [];
			for (var i = 0; i < notificationEmails1.length; i++) {
				notificationEmails.push(notificationEmails1[i].trim());
			}
			var temp = scope.settings.notificationEmails;
			scope.notificationSettings.notificationEmails = notificationEmails;

			brokerSettingsService.setBrokerNotificationSettings(scope.notificationSettings)
				.then(function() {
					scope.settings.isSearchable = scope.notificationSettings.isSearchable;
					scope.settings.notifyOnProfileChange = scope.notificationSettings.notifyOnProfileChange;
					scope.settings.notifyOnW9Change = scope.notificationSettings.notifyOnW9Change;
					scope.settings.notifyOnInsuranceChange = scope.notificationSettings.notifyOnInsuranceChange;
					scope.settings.notifyOnContractSignings = scope.notificationSettings.notifyOnContractSignings;
					scope.settings.notifyOnAttachmentChange = scope.notificationSettings.notifyOnAttachmentChange;
					scope.settings.notificationEmails = scope.notificationSettings.notificationEmails;
					sendSave();
				}).catch(function () {
					scope.settings.notificationEmails = temp;
				});
		}


		function saveMessage(view) {
			brokerSettingsService.updateMessage(view, scope[view].message, scope[view].isDisabled)
				.then(function () {
					scope.settings[view] = getBrokerMessage(scope[view].message, scope[view].isDisabled);
					cloneMessage(true, view);
					sendSave();
				});
		}

		function isSaveButtonDisabled() {
			return scope.view !== 'insuranceMessage' && scope.view !== 'signedMessage' && scope[scope.view] &&
				!scope[scope.view].message && scope[scope.view].isDisabled || !scope.isDirty;
		}

		function clearDiscard() {
			trueDiscard = false;
		}

		function setClean() {
			scope.isDirty = false;
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_CLEAN);
		}

		function setDirty() {
			scope.isDirty = true;
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_DIRTY);
		}

		function sendSave() {
			scope.isDirty = false;
			clearDiscard();
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_SAVE_VIEW);
		}

		function setLogoImgURL() {
			if (scope.logoSettings.imageFile) {
				scope.logoSettings.imgUrl = 'data:' +
					scope.logoSettings.imageMimeType +
					';base64,' +
					scope.logoSettings.imageFile;
			} else {
				scope.logoSettings.imgUrl = '';
			}
		}

		function toggleSettings(view) {
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_CHANGE_VIEW);
			
			scope.view = view;

			if (settingsListener) {
				settingsListener(); //unregister the watch on current settings
				settingsListener = undefined;
			}
			discardChanges();
		}

		function uploadLogo(files) {
			if (files && files.length === 1) {
				var file = files[0];

				scope.logoSettings.filetype = file.type;
				scope.logoSettings.filesize = file.size;
				scope.logoSettings.fileName = file.name.substring(0, file.name.lastIndexOf('.'));
				scope.logoSettings.fileExtension = file.name
					.substring(file.name.lastIndexOf('.') + 1, file.name.length);

				if (!isValidFileType(scope.logoSettings.fileExtension)) {
					scope.ShowIsInvalidFile = true;

					return;
				} else {
					scope.ShowIsInvalidFile = false;
				}

				ngFileUpload.base64DataUrl(file, false)
					.then(function(url) {
						// eslint-disable-next-line no-useless-escape
						var re = /[^data\:].*;/;

						scope.logoSettings.imageFile = url.split(',')[1];
						var imageMimeType = re.exec(url)[0];
						scope.logoSettings.imageMimeType = imageMimeType.substring(0, imageMimeType.length - 1);
						setDirty();
						scope.logoSettings.testImgUrl = 'data:' +
							scope.logoSettings.imageMimeType +
							';base64,' +
							scope.logoSettings.imageFile;
					});
			}
		}

		function validateLogoImage() {
			if (scope.isDirty) {
				var img = document.getElementById('logoSettings-testImg');
				var width = img.clientWidth;
				var height = img.clientHeight;

				if (scope.logoSettings.filesize > 150000 || width > 300 || height > 150) {
					scope.ShowIsInvalidFile = true;

					scope.logoSettings.imageFile = scope.settings.imageFile;
					scope.logoSettings.imageMimeType = scope.settings.imageMimeType;
				} else {
					scope.ShowIsInvalidFile = false;
					setLogoImgURL();
				}
			}
		}

		function isValidFileType(fileExtension) {
			return (fileExtension.toLowerCase() === 'png' ||
				fileExtension.toLowerCase() === 'gif' ||
				fileExtension.toLowerCase() === 'jpg' ||
				fileExtension.toLowerCase() === 'jpeg');
		}

		function validateNotificationEmail() {

			scope.showEmailIsNotValid = false;

			var notificationEmails;
			if (typeof scope.notificationSettings.notificationEmails === 'string')
				notificationEmails = scope.notificationSettings.notificationEmails.split(',');
			else
				notificationEmails = scope.notificationSettings.notificationEmails;
			for (var i = 0; i < notificationEmails.length; i++) {
				var email = notificationEmails[i].trim();
				if (!validationService.isValidEmail(email)) {
					scope.showEmailIsNotValid = true;

					return;
				}
			}
			
		}

		function toggleModalWindow() {
			scope.showModalWindow = !scope.showModalWindow;
		}
	}
})();
